<template>
  <div
    ref="ref"
    v-if="filteredObjectives"
    class="relative space-y-4 t3m-ObjectiveFinder-list sm:space-y-0 sm:grid sm:grid-cols-2 t3m-con-gut-sm 2xl:grid-cols-3"
  >
    <objective-first
      v-for="(o, index) in moreObjects"
      :key="o.id"
      :index="index"
      :specs="o"
    />
    <objective-details v-if="selectedObjective" />
    <div
      v-if="loadedMore && filteredObjectives.length > 12"
      class="relative flex justify-center sm:col-span-2 2xl:col-span-3"
    >
      <button
        class="btn btn-sm btn-primary max-w-80"
        @click="loadMoreObjects()"
      >
        Show all results
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ObjectiveFirst from '@/components/ObjectiveFirst.vue'
import ObjectiveDetails from '@/components/ObjectiveDetails.vue'

export default {
  name: 'ObjectiveList',
  computed: {
    ...mapState([
      'contrastMethodSets',
      'selectedObjective',
      'filteredObjectives',
    ]),
    moreObjects() {
      return this.filteredObjectives.slice(0, this.length)
    },
  },
  components: {
    ObjectiveFirst,
    ObjectiveDetails,
  },
  data() {
    return {
      length: 12,
      loadedMore: true,
    }
  },
  updated() {
    if (
      this.$refs.ref.getBoundingClientRect().bottom <
      window.innerHeight / 4
    ) {
      this.setListOutOfView(true)
    } else {
      this.setListOutOfView(false)
    }
  },
  methods: {
    ...mapActions(['setListOutOfView']),

    loadMoreObjects() {
      this.length = this.filteredObjectives.length
      this.loadedMore = false
    },
  },
}
</script>
